
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/stores",
      function () {
        return require("private-next-pages/brands/stores/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/stores"])
      });
    }
  